import {
  LIST_BRANCH_SERVICE_CATEGORY_REQUEST,
  LIST_BRANCH_SERVICE_CATEGORY_SUCCESS,
  LIST_BRANCH_SERVICE_CATEGORY_FAIL,
  PATCH_BRANCH_SERVICE_CATEGORY_REQUEST,
  PATCH_BRANCH_SERVICE_CATEGORY_SUCCESS,
  PATCH_BRANCH_SERVICE_CATEGORY_FAIL,
  DETAIL_BRANCH_SERVICE_CATEGORY_REQUEST,
  DETAIL_BRANCH_SERVICE_CATEGORY_SUCCESS,
  DETAIL_BRANCH_SERVICE_CATEGORY_FAIL
} from '../../constants/branch-service-category'

const initialState = {
  loadingServicePriceCategory: false,
  loadingDetailServicePriceCategory: false,
  loadingPatchServicePriceCategory: false,
  ServicePriceCategorys: [],
  ServicePriceCategory: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const servicePriceCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_BRANCH_SERVICE_CATEGORY_REQUEST:
      return { ...state, loadingServicePriceCategory: true }
    case LIST_BRANCH_SERVICE_CATEGORY_SUCCESS:
      return {
        ...state,
        loadingServicePriceCategory: false,
        ServicePriceCategorys: action.payload,
        pageable: action.pageable
      }
    case LIST_BRANCH_SERVICE_CATEGORY_FAIL:
      return {
        ...state,
        loadingServicePriceCategory: false,
        error: action.payload
      }
    case PATCH_BRANCH_SERVICE_CATEGORY_REQUEST:
      return { ...state, loadingPatchServicePriceCategory: true }
    case PATCH_BRANCH_SERVICE_CATEGORY_SUCCESS:
      return {
        ...state,
        loadingPatchServicePriceCategory: false,
        ServicePriceCategoryDetail: action.payload,
        pageable: action.pageable
      }
    case PATCH_BRANCH_SERVICE_CATEGORY_FAIL:
      return {
        ...state,
        loadingPatchServicePriceCategory: false,
        error: action.payload
      }
    case DETAIL_BRANCH_SERVICE_CATEGORY_REQUEST:
      return {
        ...state,
        loadingDetailServicePriceCategory: true,
        error: null,
        ServicePriceCategory: {}
      }
    case DETAIL_BRANCH_SERVICE_CATEGORY_SUCCESS:
      return {
        ...state,
        loadingDetailServicePriceCategory: false,
        ServicePriceCategory: action.payload,
        error: null
      }
    case DETAIL_BRANCH_SERVICE_CATEGORY_FAIL:
      return {
        ...state,
        loadingDetailServicePriceCategory: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default servicePriceCategoryReducer
